// C3 · الموظفين + البحث المزدوج — per-screen i18n namespace (ar-first + en parity).
// Merged into the shared vivo messages by i18n.ts via require.context('./screens').
module.exports = {
  ar: {
    employees: {
      title: 'الموظفين',
      assign: {
        open: 'تعيين بوليصة',
        title: 'تعيين بوليصة لعدة موظفين',
        close: 'إغلاق',
        policy: 'البوليصة',
        policyPlaceholder: 'اختر بوليصة سارية',
        target: 'الموظفون المستهدفون',
        modeSelected: 'الموظفون المحددون ({n})',
        modeUnassigned: 'كل الموظفين بدون بوليصة',
        overwrite: 'استبدال البوليصة الحالية إن وُجدت',
        submit: 'تعيين',
        submitting: 'جارٍ التعيين…',
        selectAll: 'تحديد كل الصفوف',
        selectRow: 'تحديد {name}',
        result: 'تم تعيين البوليصة لـ {assigned} من {matched} موظف.',
        skippedTitle: 'تم تخطّي {n}:',
        reasons: {
          EMPLOYEE_NOT_FOUND: 'الموظف غير موجود',
          COMPANY_MISMATCH: 'الموظف يتبع شركة أخرى',
          EMPLOYEE_NOT_ACTIVE: 'الموظف غير نشط',
          ALREADY_ASSIGNED: 'مرتبط بهذه البوليصة بالفعل',
          HAS_OTHER_POLICY: 'لديه بوليصة أخرى (فعّل الاستبدال لتغييرها)',
        },
        errors: {
          policyRequired: 'اختر البوليصة',
          noSelection: 'حدد موظفًا واحدًا على الأقل',
          tooMany: 'الحد الأقصى 5000 موظف في الطلب الواحد',
        },
        apiErrors: {
          policiesLoad: 'تعذّر تحميل قائمة البوالص',
          POLICY_NOT_FOUND: 'البوليصة غير موجودة في شركتك',
          POLICY_NOT_ACTIVE: 'البوليصة غير سارية ولا يمكن التعيين عليها',
          INVALID_ASSIGNMENT_TARGET: 'تحديد الموظفين غير صالح',
          FORBIDDEN: 'ليس لديك صلاحية تعيين البوالص',
          network: 'تعذّر الاتصال بالخادم، حاول مرة أخرى',
          generic: 'تعذّر تعيين البوليصة، حاول مرة أخرى',
        },
      },
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل البيانات',
      searchPlaceholder: 'اسم / رقم بوليصة / رقم قومي',
      newEmployee: 'موظف',
      add: 'إضافة',
      uploadExcel: 'رفع Excel',
      all: 'الكل',
      allDepartments: 'كل الأقسام',
      status: { active: 'نشط', suspended: 'موقوف', left: 'مغادر' },
      col: {
        employee: 'الموظف',
        nationalId: 'الرقم القومي',
        dept: 'القسم',
        policyNo: 'رقم البوليصة',
        hireDate: 'تاريخ التعيين',
        status: 'الحالة',
      },
      open: 'فتح',
      empty: 'لا يوجد موظفون مطابقون لهذا البحث',
      showing: 'عرض',
      of: 'من',
      employeeUnit: 'موظف',
      prev: '‹ السابق',
      next: 'التالي ›',
      filter: {
        button: 'الفلاتر',
        clear: 'مسح الفلاتر',
        done: 'تم',
      },
      delete: {
        button: 'حذف',
        hint: 'حذف ناعم — الموظف يختفي من القوائم وبياناته ومطالباته تفضل محفوظة',
        yes: 'نعم، احذف',
        cancel: 'إلغاء',
        deleting: 'جارٍ الحذف…',
        done: 'تم حذف {name} — بياناته ومطالباته لسه محفوظة، ولو رجع تقدر تضيفه تاني بنفس الرقم القومي',
        errors: {
          notFound: 'الموظف مش موجود أصلاً (يمكن اتحذف قبل كده) — حدّث الصفحة',
          forbidden: 'مش مسموح لك بحذف الموظف دا',
          conflict: 'مش ممكن الحذف دلوقتي — فيه بيانات مرتبطة بتمنع العملية',
          network: 'فيه مشكلة في الشبكة — جرّب تاني',
          generic: 'تعذّر حذف الموظف — جرّب تاني',
        },
      },
      assistant: {
        title: 'المساعد الذكي',
        hint: 'اسأله عن الموظفين بلغتك العادية — أو اسأله سؤال عن تغطيات الشركة',
        placeholder: 'مثال: أحضر لي موظفي المبيعات الموقوفين · كم عدد الموظفين النشطين؟ · ابحث عن أحمد',
        send: 'اسأل',
        thinking: 'جارٍ البحث…',
        applied: 'طبّقت الفلاتر على القائمة تحت — امسحها من زرار «الفلاتر» لو عايز ترجع لكل الموظفين.',
        employeesList: 'لقيت {n} موظف — الحالة: {status}، القسم: {dept}. القائمة تحت بقت عليهم.',
        employeesCount: 'عددهم {n} موظف — الحالة: {status}، القسم: {dept}.',
        employeesNone: 'مفيش موظف بالمواصفات دي (الحالة: {status}، القسم: {dept}). جرّب تشيل شرط منهم.',
        noMatch:
          'مفيش إجابة للسؤال دا في بنك أسئلة الشركة. المساعد بيجاوب على نوعين: أسئلة عن الموظفين (زي «الموقوفين في المبيعات») بيجاوبها من قائمة الموظفين على طول، وأسئلة التغطيات والمزايا بيجاوبها من بنك أسئلة الشركة — والبنك لسه فاضي.',
        fillBank: 'افتح شاشة «أسئلة الشركة» وضيف الأسئلة والأجوبة ←',
        errors: {
          network: 'فيه مشكلة في الشبكة — جرّب تاني.',
          throttled: 'أسئلة كتير في وقت قصير — استنى شوية وجرّب تاني.',
          forbidden: 'مش مسموح لك تسأل المساعد — كلّم أدمن شركة التأمين.',
          server: 'في مشكلة في السيرفر وقت الإجابة — جرّب تاني، ولو فضلت كلّم الدعم.',
          badQuestion: 'السؤال مش مفهوم — جرّب تكتبه بشكل تاني أو أقصر.',
          generic: 'تعذّر الإجابة على السؤال — جرّب تاني.',
        },
      },
    },
  },
  en: {
    employees: {
      title: 'Employees',
      assign: {
        open: 'Assign policy',
        title: 'Assign a policy to several employees',
        close: 'Close',
        policy: 'Policy',
        policyPlaceholder: 'Select an active policy',
        target: 'Target employees',
        modeSelected: 'Selected employees ({n})',
        modeUnassigned: 'All employees without a policy',
        overwrite: 'Replace the current policy if any',
        submit: 'Assign',
        submitting: 'Assigning…',
        selectAll: 'Select all rows',
        selectRow: 'Select {name}',
        result: 'Policy assigned to {assigned} of {matched} employees.',
        skippedTitle: '{n} skipped:',
        reasons: {
          EMPLOYEE_NOT_FOUND: 'Employee not found',
          COMPANY_MISMATCH: 'Employee belongs to another company',
          EMPLOYEE_NOT_ACTIVE: 'Employee is not active',
          ALREADY_ASSIGNED: 'Already on this policy',
          HAS_OTHER_POLICY: 'Has another policy (enable replace to change it)',
        },
        errors: {
          policyRequired: 'Select a policy',
          noSelection: 'Select at least one employee',
          tooMany: 'At most 5000 employees per request',
        },
        apiErrors: {
          policiesLoad: 'Could not load the policy list',
          POLICY_NOT_FOUND: 'Policy not found in your company',
          POLICY_NOT_ACTIVE: 'The policy is not active and cannot be assigned',
          INVALID_ASSIGNMENT_TARGET: 'Invalid employee selection',
          FORBIDDEN: 'You do not have permission to assign policies',
          network: 'Could not reach the server, please try again',
          generic: 'Could not assign the policy, please try again',
        },
      },
      loading: 'Loading…',
      error: 'Something went wrong while loading data',
      searchPlaceholder: 'Name / policy no. / national ID',
      newEmployee: 'Employee',
      add: 'Add',
      uploadExcel: 'Upload Excel',
      all: 'All',
      allDepartments: 'All departments',
      status: { active: 'Active', suspended: 'Suspended', left: 'Left' },
      col: {
        employee: 'Employee',
        nationalId: 'National ID',
        dept: 'Department',
        policyNo: 'Policy no.',
        hireDate: 'Hire date',
        status: 'Status',
      },
      open: 'Open',
      empty: 'No employees match your search',
      showing: 'Showing',
      of: 'of',
      employeeUnit: 'employees',
      prev: '‹ Prev',
      next: 'Next ›',
      filter: {
        button: 'Filters',
        clear: 'Clear filters',
        done: 'Done',
      },
      delete: {
        button: 'Delete',
        hint: 'Soft delete — the employee leaves every list; their record and claims are kept',
        yes: 'Yes, delete',
        cancel: 'Cancel',
        deleting: 'Deleting…',
        done: '{name} deleted — their record and claims are kept, and the same national ID can be added again',
        errors: {
          notFound: 'That employee no longer exists (it may already be deleted) — refresh the page',
          forbidden: 'You are not allowed to delete this employee',
          conflict: 'Cannot delete right now — linked data is blocking it',
          network: 'Network problem — please try again',
          generic: 'Could not delete the employee — please try again',
        },
      },
      assistant: {
        title: 'Smart assistant',
        hint: 'Ask about your employees in plain language — or ask a question about the company’s coverage',
        placeholder: 'e.g. show me the suspended Sales employees · how many active employees? · find Ahmed',
        send: 'Ask',
        thinking: 'Searching…',
        applied: 'The list below is filtered to match — clear it from the “Filters” button to see everyone again.',
        employeesList: 'Found {n} employee(s) — status: {status}, department: {dept}. The list below now shows them.',
        employeesCount: 'There are {n} — status: {status}, department: {dept}.',
        employeesNone: 'No employee matches that (status: {status}, department: {dept}). Try dropping one of the conditions.',
        noMatch:
          'Nothing in the company Q&A bank answers that. The assistant handles two kinds of question: questions about employees (like “suspended in Sales”), answered straight from the employee list, and questions about coverage and benefits, answered from the company Q&A bank — which is still empty.',
        fillBank: 'Open the Company Q&A screen and add questions and answers →',
        errors: {
          network: 'Network problem — please try again.',
          throttled: 'Too many questions too quickly — wait a moment and try again.',
          forbidden: 'You are not allowed to use the assistant — contact the insurer admin.',
          server: 'The server failed while answering — try again, and contact support if it persists.',
          badQuestion: 'That question could not be read — try rephrasing it, or make it shorter.',
          generic: 'Could not answer that — please try again.',
        },
      },
    },
  },
};
